module.exports = __webpack_public_path__ + "img/8.7ee74a02.png";